export default "__VITE_ASSET__Ck2C_pwn__"